import { TableColumnType } from 'src/types/table';

export const allColumns: TableColumnType[] = [
    {
        key: 'rawLabel',
        label: 'label',
        customRender: true,
    },
    {
        key: 'value',
        label: 'value',
        customRender: true,
    },
    {
        key: 'shipperCode',
        label: 'shipperCode',
        customRender: true,
        type: 'select',
        selectOption: 'shipperCodes',
    },
    {
        key: 'isExpedition',
        label: 'isExpedition',
        customRender: true,
        type: 'select',
        selectOption: 'boolNumberCodes',
    },
    {
        key: 'isReturn',
        label: 'isReturn',
        customRender: true,
        type: 'select',
        selectOption: 'boolNumberCodes',
    },
    {
        key: 'countryCodesSelect',
        label: 'countryCodesSelect',
        customRender: true,
        disableFilter: true,
        disableSort: true,
    },
    {
        key: 'color',
        label: 'color',
        customRender: true,
    },
    {
        key: 'editOrder',
        label: 'editOrder',
        type: 'select',
        selectOption: 'boolCodes',
    },
    {
        key: 'ORDER_INT',
        label: 'ORDER_INT',
        type: 'number',
    },
    {
        key: 'awaiting',
        label: 'awaiting',
        type: 'select',
        selectOption: 'boolCodes',
    },
    {
        key: 'LANG',
        label: 'lang',
        customRender: true,
        type: 'select',
        selectOption: 'langCodes',
    },
];

export const editRows = [
    'claimReasonCodes',
    'documentTypesCodes',
    'expeditionMethodCodes',
    'handlingUnitsCodes',
    'paymentCodes',
    'productTypeCodes',
    'productRelationCodes',
    'retunReasonCodes',
    'returnResolutionCodes',
    'shipperCodes',
    'serviceCodes',
    'shipperMessageCodes',
    'claimsResolverCodes',
    'receivingDeliveryTypeCodes',
    'receivingUrgentCodes',
    'receivingPackingTypeCodes',
    'receivingPalletCodes',
    'productInsetTypeCodes',
    'emailTemplateTypeCodes',
    'orderPriorityCodes',
    'productCompletionSheetStatusCodes',
    'stockTakingStatusCodes',
    'stockTakingTypeCodes',
    'transportTypeCodes',
    'orderProductCustomsTypeCodes',
    'jobStatusCodes',
    'jobUnitCodes',
    'jobCategoryCodes',
    'jobDepartmentCodes',
    'jobShipperCodes',
    'carrierExtraFeeTypeCodes',
    'driverCompanyCodes',
    'providerSystemCodes',
    'sourceSysCodes',
    'transportPaidByCodes',
    'salesRepresentativeCodes',
    'keyAccountManagerCodes',
];
